import { useDispatch, useSelector } from 'react-redux';

import {
  getListDatesHasVideo,
  getListVideo,
  listDatesHasEvaluation,
  getEvaluationDetail as evaluationDetail,
  checkStatusLastEvaluation,
  getChildrenDetail,
} from 'api/endpoints/children';
import { clearChildrenDetail, setChildrenDetail } from 'store/actions/children';
import { clearReport } from 'store/actions/report';
import { clearVideoCategories } from 'store/actions/video-catergory';
import { convertToQueryString, handleError } from 'utils/helper';

const useChildren = () => {
  const dispatch = useDispatch();
  const { childrenDetail } = useSelector((state) => state.children);

  /**
   * Get the list of dates that have videos of the child
   * @returns {Promise<void>}
   */
  const getDatesHasVideo = async (queryString = '') => {
    const response = await getListDatesHasVideo(childrenDetail?.id, queryString);
    if (response?.data) {
      return response?.data;
    }
    return [];
  };

  /**
   * Get the list of exercise video selection
   * @param {string} date
   * @returns {Promise<void>}
   */
  const getExerciseVideoSelection = async (report_ids = []) => {
    const query = convertToQueryString({ report_ids });
    const response = await getListVideo(childrenDetail?.id, query);
    if (response?.data) {
      return response?.data;
    }
  };

  /**
   * List the dates that have evaluations of the child
   * @returns {Promise<void>}
   */
  const getDatesHasEvaluation = async ({ page = 1, page_size = 50 }) => {
    const query = convertToQueryString({ page, page_size });
    const response = await listDatesHasEvaluation(childrenDetail?.id, query);
    if (response?.data) {
      return response?.data;
    }
    return [];
  };

  /**
   * Get the detail of an evaluation
   * @param {string} id
   * @returns {Promise<void>}
   */
  const getEvaluationDetail = async (id) => {
    const response = await evaluationDetail(id);
    if (response?.data) {
      return response?.data;
    }
    return null;
  };

  /**
   * Check the status of the last evaluation
   * @param {string} child_id
   * @returns {Promise<void>}
   */
  const getStatusLastEvaluation = async (child_id) => {
    const response = await checkStatusLastEvaluation(child_id);
    if (response?.data) {
      return response?.data;
    }
    return null;
  };

  /**
   * Get the detail of the child
   * @param {string} child_id
   * @returns {Promise<void>}
   */
  const getDetailChild = async (child_id) => {
    try {
      const response = await getChildrenDetail(child_id);
      dispatch(setChildrenDetail(response.data));
    } catch (error) {
      handleError(error);
    }
  };

  /**
   * Clear all data of the child
   */
  const clearAllData = () => {
    dispatch(clearChildrenDetail());
    dispatch(clearReport());
    dispatch(clearVideoCategories());
  };

  return {
    clearAllData,
    getDatesHasVideo,
    getExerciseVideoSelection,
    getDatesHasEvaluation,
    getEvaluationDetail,
    getStatusLastEvaluation,
    getDetailChild,
  };
};

export default useChildren;
